import axios from 'axios';

const api = axios.create({
    baseURL: 'https://pedidos.lemontcafe.com.br/api/'
});

export default api;
